import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { PlayIcon } from 'lucide-react';
export const Webinar2Page: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] text-white font-sans selection:bg-green-500/30" data-id="element-2396">
      {/* Header */}
      <header className="py-6 text-center border-b border-gray-800/50" data-id="element-2397"></header>

      <main className="max-w-2xl mx-auto px-4 py-8 md:py-12" data-id="element-2398">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-2399">
          {/* Hero Image */}
          <div className="relative rounded-2xl overflow-hidden mb-8 shadow-2xl shadow-black/50 ring-1 ring-white/10" data-id="element-2400">
            {/* Desktop image */}
            <img src="https://cdn.magicpatterns.com/uploads/iXzoZySTwsDcssGmHJToA2/POZOR_POHODLNE_SE_USAD_A_POSLOUCHEJ._TYTO_RADY_TI_UKAZOU_CESTU_K_VYSNENE_POSTAVE.jpg" alt="Pozor, pohodlně se usaď a poslouchej" className="hidden md:block w-full h-auto object-cover" data-id="element-2401" />
            {/* Mobile image */}
            <img src="https://cdn.magicpatterns.com/uploads/raMXKtrdFHNyHXV2qXxTVy/POZOR_POHODLNE_SE_USAD_A_POSLOUCHEJ._TYTO_RADY_TI_UKAZOU_CESTU_K_VYSNENE_POSTAVE_(1).jpg" alt="Pozor, pohodlně se usaď a poslouchej" className="block md:hidden w-full h-auto object-cover" data-id="element-2402" />
          </div>

          {/* Text Section */}
          <div className="space-y-6 mb-10 text-center" data-id="element-2403">
            <div className="inline-block px-4 py-1.5 rounded-full border border-green-500/30 bg-green-500/10 text-green-500 font-bold text-sm md:text-base shadow-[0_0_15px_rgba(34,197,94,0.15)]" data-id="element-2404">
              [ Webinář Zpřístupněn! 🔓 ]
            </div>

            <h1 className="text-2xl md:text-3xl font-bold leading-tight text-white" data-id="element-2405">
              💪 10 rad, které pomohly mně i mým klientům dosáhnout vysněné
              postavy už za 90 dní. 🔥
            </h1>
          </div>

          {/* Recommendation text */}
          <div className="space-y-4 mb-10 text-base md:text-lg text-gray-300 leading-relaxed" data-id="element-2406">
            <p data-id="element-2407">
              Doporučuji si vyhradit přibližně{' '}
              <strong className="text-white" data-id="element-2408">10 minut svého času</strong>. Každá
              rada trvá jen cca 1 minutu, ale dohromady ti můžou dát{' '}
              <strong className="text-white" data-id="element-2409">výsledky</strong>, po kterých{' '}
              <strong className="text-white" data-id="element-2410">toužíš už odjakživa</strong>. 🔥
            </p>
            <p data-id="element-2411">
              ⚡ A pokud chceš{' '}
              <strong className="text-white" data-id="element-2412">ušetřit čas</strong>, klidně si
              video zrychli — hlavní je, abys ty informace{' '}
              <strong className="text-white" data-id="element-2413">opravdu využil</strong>.
            </p>
          </div>

          {/* Video */}
          <div className="mb-12 relative w-full aspect-video rounded-2xl overflow-hidden shadow-xl border border-gray-800" data-id="element-2414">
            <iframe src="https://www.veed.io/embed/c96aedfd-44e0-462e-a23e-8869d300a479?watermark=0&color=&sharing=1&title=0" className="absolute inset-0 w-full h-full" frameBorder="0" title="Webinar Video" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen data-id="element-2415" />
          </div>

          {/* Text below video */}
          <div className="space-y-6 mb-10 text-base md:text-lg text-gray-300 leading-relaxed" data-id="element-2416">
            <p data-id="element-2417">
              Pokud tě tohle video{' '}
              <strong className="text-white" data-id="element-2418">zaujalo</strong>, je dost možné, že
              jsi v něm slyšel něco, co jsi{' '}
              <strong className="text-white" data-id="element-2419">doposud nikdy neslyšel</strong>.
            </p>
            <p data-id="element-2420">
              Možná právě teď začínáš chápat, že{' '}
              <strong className="text-white" data-id="element-2421">růst svalů není o náhodě</strong>,
              ale o <strong className="text-white" data-id="element-2422">systému</strong>.
            </p>
            <p data-id="element-2423">
              A pokud chceš vědět,{' '}
              <strong className="text-white" data-id="element-2424">
                jak přesně tenhle systém funguje
              </strong>{' '}
              a jak ho můžeš začít využívat i ty k{' '}
              <strong className="text-white" data-id="element-2425">
                dosažení své vysněné postavy
              </strong>
              , klikni na tlačítko níže a zjisti více o{' '}
              <strong className="text-white" data-id="element-2426">BHS – Body Hack System</strong>.
            </p>
          </div>

          {/* CTA Box */}
          <div className="mb-16" data-id="element-2427">
            <a href="https://calendly.com/ondrej-janik-body-hack/15-minutovy-meeting-bhs-a" target="_blank" rel="noopener noreferrer" className="block w-full bg-green-500 hover:bg-green-400 text-black font-black text-xl py-5 rounded-xl transition-all duration-300 shadow-[0_0_20px_rgba(34,197,94,0.3)] hover:shadow-[0_0_30px_rgba(34,197,94,0.5)] active:scale-[0.98] text-center" data-id="element-2428">
              CHCI ONLINE MEETING ZDARMA!
            </a>
          </div>

          {/* Footer Link */}
          <div className="text-center pb-8" data-id="element-2429">
            <a href="#" className="text-sm text-gray-500 hover:text-gray-300 underline transition-colors" data-id="element-2430">
              Privacy Policy
            </a>
          </div>
        </motion.div>
      </main>
    </div>;
};